@if (item) {
  <article class="personal-item personal-item--opened" #element>
    <header
      class="personal-item__section personal-item__section--header"
      (click)="toggleCollapsed(item)"
      [attr.aria-expanded]="!isCollapsed"
    >
      <div class="right-item-block">
        <div class="controls" [formGroup]="form">
          @if (item.delivery_type !== 'virtual') {
            <app-input-plus-minus
              stopPropagation
              formstopPropagation
              formControlName="price"
              [max]="1000"
            ></app-input-plus-minus>
          } @else {
            <div class="personal-item__sub-title mb-0">
              {{ 'AMOUNT' | translate }}: {{ item.amount }}
            </div>
          }
          <section>
            <div class="personal-item__title personal-item__title--price">
              {{ item?.price | number: '1.2-2' }} {{ 'BYN' | translate }}
              @if (item.include_nds) {
                <span class="ml-1 lowercase price-nds sub-price"
                  >{{ 'INCLUDE_NDS_SHORT' | translate }}:
                  {{ item.include_nds | number: '1.2-2' }}
                  {{ 'BYN' | translate }}</span
                >
              }
            </div>
            <fa-icon
              (click)="onDeleteItem(item)"
              stopPropagation
              class="personal-item__chevron personal-item__chevron--grey"
              [icon]="faTrashAlt"
            ></fa-icon>
          </section>
        </div>
      </div>
      <h3 class="personal-item__title flex-end">
        <a
          stopPropagation
          [routerLink]="
            url + '/items/' + item?.basketable?.publication?.id | localize
          "
        >
          <img [src]="item?.basketable?.publication?.img" />
        </a>
        <div class="personal-item">
          <a
            stopPropagation
            [routerLink]="
              url + '/items/' + item?.basketable?.publication?.id | localize
            "
            class="personal-item__title"
          >
            {{ item?.basketable?.publication?.name || '-' }}
            <!-- <a *ngIf="item?.basketable?.publication"
          [routerLink]="url + '/items/' + item?.basketable?.publication?.id | localize"
          class="ml-2"
          stopPropagation>
          <fa-icon class="personal-item__link"
            size="xs"
            stopPropagation
            (click)="onDeleteItem(item)"
          [icon]="link"></fa-icon>
        </a> -->
          </a>
          <div class="personal-item__sub-title">
            <span class="pr-2">
              {{ deliveryMap[item?.delivery_type] | translate }}
            </span>
            <a class="pointer">{{ 'MORE_DETAILS' | translate }}</a>
          </div>
        </div>
      </h3>
    </header>
    @if (!isCollapsed) {
      <div class="personal-item__section" @fadeIn>
        @if (item?.basketable?.type) {
          <h4
            class="personal-item__title personal-item__title--space font-weight-normal"
          >
            {{ item?.basketable?.type | translate }}
          </h4>
        }
        @if (item?.basketable?.index) {
          <h4
            class="personal-item__title personal-item__title--space font-weight-normal"
          >
            {{ 'INDEX' | translate }}: {{ item?.basketable?.index }}
          </h4>
        }
        <!-- <h4 class="personal-item__title personal-item__title--space font-weight-normal"
    *ngIf="item?.delivery_type">
    {{ 'DELIVERY_TYPE_TITLE' | translate }}: {{ deliveryMap[item?.delivery_type] | translate }}
  </h4> -->
        <h4
          class="personal-item__title personal-item__title--space font-weight-normal"
        >
          <span
            >{{ 'SUBSCRIPTION_PERIOD' | translate }}
            @if (item?.basketable?.start_at) {
              <span
                >({{ item.basketable.start_at.slice(0, 4) }}
                {{ 'YEAR' | translate | lowercase }})</span
              >
            }
          </span>
          <div>
            <button
              type="button"
              (click)="changePeriod()"
              class="button button--link-blue float-right"
              [disabled]="!canSave && periods"
              [ngClass]="{ 'button--filled button--shadow': periods }"
            >
              {{ (periods ? 'SAVE' : 'EDIT') | translate }}
            </button>
            @if (periods) {
              <button
                type="button"
                (click)="periods = undefined"
                class="button float-right"
              >
                {{ 'CANCEL' | translate }}
              </button>
            }
          </div>
        </h4>
        @if (!periods) {
          <ul class="list-row" @fadeIn>
            @for (month of item.months; track month) {
              <li
                class="text-secondary personal-details__title font-weight-medium"
              >
                {{ getTitle(month) | translate }}
              </li>
            }
          </ul>
        }
        @if (periods) {
          <section class="subscription-block__body" @fadeIn>
            <div class="toggles toggles--sm toggles--bordered">
              @for (iitem of periods; track iitem; let i = $index) {
                <div class="toggles__item">
                  <input
                    type="checkbox"
                    (change)="checkCanSave()"
                    [name]="item.id + '_period_' + i"
                    [id]="item.id + '_period_' + i"
                    [(ngModel)]="iitem.selected"
                    [disabled]="iitem.disabled"
                  />
                  <label [for]="item.id + '_period_' + i">
                    <div class="item text-secondary">
                      <h3 class="toggles__title">
                        {{ iitem.name | translate }}
                      </h3>
                    </div>
                  </label>
                </div>
              }
            </div>
          </section>
        }
      </div>
    } @else {
      @if (!isCollapsed) {
        <div class="personal-item__section">
          <div class="col-12 text-center">
            <span
              class="spinner-border spinner-border spinner-border-lg text-secondary"
              role="status"
              aria-hidden="true"
            ></span>
          </div>
        </div>
      }
    }
  </article>
}
